
    export default 
    {
    "footer": {
        "about": "Nosotros",
        "support": "Soporte técnico",
        "privacy_policy": "Política de privacidad"
    }
}